<template>
  <div v-click-outside="closeDropdown">
    <ul
      class="report-dropdown"
      :class="{'one-column':buttonType === 1 }"
    >
      <li
        :class="{'inactive': !showDropDown, 'active': showDropDown}"
      >
        <div
          class="pointer h6"
          tabindex="0"
          @click.self="showDropDown = !showDropDown"
        >
          <tempalte
            v-if=" modelValue && modelValue?.length > 0"
          >
            <label>{{ label }}: </label>

            <span>{{ modelValue.length }} Selection(s)</span>
          </tempalte><template v-else>
            {{ label }}
          </template>
        </div>

        <ul
          v-show="showDropDown"
          :class="{'select-scroll': buttonType === 1}"
        >
          <!-- only use label for value, for easy display. will get value when send request -->
          <template
            v-if="buttonType === 1"
          >
            <template
              v-for="(optionLabel, value) in options"
              :key="'dropdown' + value"
            >
              <li
                :class="{'selected': modelValue?.includes(+value)}"
                @click="toggleValue(+value)"
              >
                <a :aria-label="'select ' + optionLabel">{{ optionLabel }} </a> <span v-if="stats && stats[value] > 0">({{ stats[value] }})</span>
              </li>
            </template>
          </template>
          <!-- when two levels of menus exist -->
          <template
            v-else
          >
            <template
              v-for="(key, index) in mainOption"
              :key="'dropdown' + index"
            >
              <li
                :class="{'selected active': selectedMainOption === key, 'inactive': selectedMainOption !== key}"
                @mouseover="expandOptions(key)"
              >
                <div>
                  {{ key }}
                </div>
                <ul
                  v-if="selectedMainOption === key"
                  class="subMenu"
                >
                  <li
                    v-for="(item, index2) in options[key]"
                    :key="'dropdown' + index2"
                    :class="{'selected': modelValue?.includes(+item.value)}"
                    @click="toggleValue(+item.value)"
                  >
                    <a
                      :aria-label="'select ' + item.label"
                      class="clickable"
                    > {{ item.label }}
                      <span v-if="stats && stats[item.value] > 0">({{ stats[item.value] }})</span>
                    </a>
                  </li>
                </ul>
              </li>
            </template>
          </template>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
/* Option key/id must be numbers */
import { Ref, ref, computed, PropType } from 'vue';

const props = defineProps({
  buttonType: { type: Number, default: 1 },
  label: { type: String, default: '' },
  modelValue: { type: Object as PropType<Array<number>|null>, default: null },
  options: { type: Object, default: null },
  stats: { type: Object, default: null }
});

const emit = defineEmits(['update:modelValue']);

const showDropDown = ref(false);
const selectedMainOption:Ref<string | null> = ref(null);
const mainOption = computed(() => {
  return Object.keys(props.options ?? []);
});
const expandOptions = (openOptionKey: string) => {
  selectedMainOption.value = openOptionKey;
};
const closeDropdown = () => {
  if (showDropDown.value) {
    showDropDown.value = false;
  }
};
const toggleValue = (value: number) => {
  let newVal;
  if (!props.modelValue?.includes(value)) {
    newVal = [...props.modelValue ?? [], value];
  } else {
    newVal = props.modelValue?.filter(x => x !== value);
  }
  emit('update:modelValue', newVal);
};
</script>
<style lang="scss" scoped>
  @import 'dropdown.scss';
</style>
